export default __webpack_public_path__ + "static/maximize_cloud-83967680dd3c97d9b4bcd44c6c7f9021.webp";